
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import * as audioActions from '../../../../Core/Game/AudioContainer/audio.actions'

import UserShield from '../../../Components/UserShield'

class SettingsConfirmation extends React.Component {
  constructor(props) {
    super(props)
  }

  next() {
    const { next, addHowlSound } = this.props
    next()
    addHowlSound('button_click_icon')
  }

  cancel() {
    const { cancel, addHowlSound } = this.props
    cancel()
    addHowlSound('button_click_icon')
  }

  render() {
    const { shield } = this.props

    return (
      <div className="container background background--mars">
        <div className="content">
          <div className="mars--confirmation">
            <UserShield shield={shield} />
            <div className="mars--confirmation__box">
              <div className="mars--confirmation__canvas">
                <p className="text">
                  <FormattedMessage id="colony.confirmation.question" />
                </p>
                <p>
                  <FormattedMessage id="colony.confirmation.alert" />
                </p>
                <div className="mars--buttons">
                  <div className="btn--shape shape--orange" onClick={() => this.next()}>
                    <div className="btn--shape__canvas">
                      <FormattedMessage id={'colony.confirmation.yes'} />
                    </div>
                  </div>
                </div>
                <p className="link" onClick={() => this.cancel()}>
                  <FormattedMessage id={'colony.confirmation.no'} />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapDispatchToProps = (dispatch) => ({
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
})

SettingsConfirmation.propTypes = {
  next: PropTypes.func,
  cancel: PropTypes.func,
  shield: PropTypes.object,
  addHowlSound: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(injectIntl(SettingsConfirmation))
